import styled from 'styled-components';

export const Container = styled.div`
	/* padding: 7.5rem 8.5rem;
	padding: 7.5rem clamp(2rem, -1.75rem + 12vw, 8.75rem); */
`;
